var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "th",
    { class: { "align-right": _vm.alignRight }, style: { width: _vm.width } },
    [
      !_vm.isDescription
        ? _c("div", {
            staticClass: "anchor",
            class: { left: _vm.afterDescription },
            on: {
              mousedown: function ($event) {
                return _vm.onAnchorMouseDown($event)
              },
            },
          })
        : _vm._e(),
      _c(
        "span",
        { staticClass: "content", style: { maxWidth: _vm.maxTextWidth } },
        [_vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }